import { SET_PRODUCTS, SET_PRODUCT } from "../actions/product"

const loader = (state, action) => {

    if (!state) {
        state = { products: [], product: {} };
    }

    switch (action.type) {
        case SET_PRODUCTS:
            const update = { products: action.products };
            if(!state.product.id && action.products.length) update.product = action.products[0]
            return Object.assign({}, state, update)
        case SET_PRODUCT:
            return Object.assign({}, state, { product: action.product })
        default:
            return state;
    }
}

export default loader;
